module.exports = __webpack_public_path__ + "img/security.ced571f5.svg";